<template>
  <div class="content">
    <TopLayoutClient :title="'Dashboard de Análise de Anúncios'" />

    <div class="row mt-4">
      <div class="col-md-12">
        <div class="quad px-3 py-2">
          <div class="row mb-3"></div>
          <hr />

          <div class="row">
            <div class="col-md-6">
              <button class="btn btn-primary">Pesquisar Anúncios</button>
            </div>
            <div class="col-md-3 offset-md-3">
              <div>
                <select class="form-select" @change="fetchPorStatus">
                  <option value="">Todos os Status</option>
                  <option value="PENDENTE">Pendente</option>
                  <option value="PENDENTE_CORTE">Aguardando Corte</option>
                  <option value="PENDENTE_ENVIO">Aguardando Envio</option>
                  <option value="ENVIADO">Enviado</option>
                  <option value="CANCELADO">Cancelado</option>
                </select>
              </div>
            </div>
            <div class="col-md-4">
              <div class="search">
                <button type="button" class="btn_search" @click="fazerPesquisa">
                  <i class="bi bi-search lupa"></i>
                </button>
                <input
                  ref="myInput"
                  type="text"
                  placeholder="SKU do Anúncio"
                  v-model="state.pesquisa_mlb"
                />
                <button
                  type="button"
                  class="btn_cancelar"
                  @click="voltarInicial"
                  style="z-index: 100"
                >
                  <i class="bi bi-x" style="font-size: 14pt; color: red"></i>
                </button>

                <div>
                  <button
                    type="button"
                    class="btn_qrcode"
                    @click="openModalQrCode"
                  >
                    <i class="bi bi-qr-code-scan"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table class="table table-hover main">
              <thead style="background-color: #560382">
                <tr style="color: #b8d941">
                  <th scope="col">ID</th>
                  <th scope="col">Cliente</th>
                  <th scope="col">Valor</th>
                  <th scope="col">Data Criação</th>
                  <th scope="col">ID do Pedido</th>
                  <th scope="col">Status</th>
                  <th scope="col">Ação</th>
                </tr>
              </thead>
              <tbody v-if="!state.loading">
                <tr
                  v-for="pedido in state.pedidos"
                  :key="pedido.id"
                  style="cursor: pointer"
                  @click="abrirModal(pedido)"
                >
                  <td>
                    {{ pedido.cod_bling }}
                  </td>
                  <td>{{ pedido.nome_cliente }}</td>
                  <td>
                    {{
                      pedido.valor_pedido.toLocaleString("pt-BR", {
                        style: "currency",
                        currency: "BRL",
                      })
                    }}
                  </td>
                  <td>
                    {{ formatarData(pedido.data_pedido) }}
                  </td>
                  <td>
                    <img
                      src="/images/shopee.svg"
                      width="20"
                      v-if="pedido.marketplace == 'shopee'"
                    />
                    <img
                      src="/images/mercadolivre.svg"
                      width="20"
                      v-if="pedido.marketplace == 'mercado_livre'"
                    />
                    <img
                      src="/images/shein.svg"
                      width="20"
                      v-if="pedido.marketplace == 'shein'"
                    />
                    {{ pedido.cod_marketplace }}
                  </td>
                  <td>{{ pedido.status }}</td>
                  <td>
                    <div class="dropdown">
                      <button
                        class="btn btn-primary dropdown-toggle"
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <i class="bi bi-caret-down-fill"></i>
                      </button>
                      <ul
                        class="dropdown-menu"
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li>
                          <a class="dropdown-item" @click="abrirModal(pedido)">
                            Visualizar
                          </a>
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="skeleton-container w-full bg-white rounded-lg p-4"
            v-if="state.loading"
          >
            <div class="skeleton h-6 mb-4 w-full"></div>
            <div class="skeleton h-6 mb-4 w-full"></div>
            <div class="skeleton h-6 mb-4 w-full"></div>
            <div class="skeleton h-6 mb-4 w-full"></div>
            <div class="skeleton h-6 mb-4 w-full"></div>
            <div class="skeleton h-6 w-full"></div>
          </div>

          <nav aria-label="Page navigation example">
            <ul class="pagination">
              <li class="page-item">
                <a class="page-link btn_bread" href="#">Anterior</a>
              </li>
              <li
                class="page-item"
                v-for="i in state.qtd_paginas"
                :key="i"
                :class="{ active: i === state.n_pagina }"
              >
                <a class="page-link" @click="buscarAnunciosPorPagina(i)">{{
                  i
                }}</a>
              </li>
              <li class="page-item">
                <a class="page-link btn_bread" href="#">Próxima</a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
  <Modal
    :open="state.modalOpen"
    @close="state.modalOpen = !state.modalOpen"
    :width="'800px'"
    v-if="state.pedido_selecionado"
  >
  <div class="modal_header">
    <h2>Pedido {{ state.pedido_selecionado.cod_bling }}</h2>
  </div>
    <hr />
    <div class="modal_content">
      <div class="row">
        <div class="col-md-6">
          <label>Colaborador Responsável</label>
          <input
            type="text"
            class="form-control"
            readonly
            v-model="state.nome_colaborador"
          />
        </div>
        <div class="col-md-6 text-end">
          <button @click="tornarResponsavel()" class="tornar-responsavel">
            Tornar-me Responsável
          </button>
        </div>
      </div>
      <hr />
      <div class="row">
        <div class="col-md-6">
          <label>Cliente</label>
          <input
            type="text"
            readonly
            class="form-control"
            v-model="state.pedido_selecionado.nome_cliente"
          />
        </div>
        <div class="col-md-3 offset-md-3">
          <label>Status</label>
          <select class="form-select">
            <option value="PENDENTE">Pendente</option>
            <option value="PENDENTE_CORTE">Aguardando Corte</option>
            <option value="PENDENTE_ENVIO">Aguardando Envio</option>
            <option value="ENVIADO">Enviado</option>
            <option value="CANCELADO">Cancelado</option>
          </select>
        </div>
      </div>
      <hr />
      <h4>Produtos</h4>
      <table class="table" style="width: 100%">
        <thead style="background-color: rgb(86, 3, 130)">
          <tr>
            <th scope="col">Produto</th>
            <th scope="col">Preço</th>
            <th scope="col">Qtd</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in state.pedido_selecionado.itens" :key="item.id">
            <td scope="col" class="d-flex gap-3 text-wrap">
              <img :src="item.produto.imagem" />

              {{ item.produto.nome }}
            </td>
            <td>
              {{
                item.produto.preco.toLocaleString("pt-BR", {
                  style: "currency",
                  currency: "BRL",
                })
              }}
            </td>
            <td class="text-center">{{ item.quantidade }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <hr />
    <div class="btns_right">
      <button @click="salvarPedido" type="button" class="btn btn-success">
        Salvar
      </button>
      <button type="button" class="btn btn-danger" @click="fecharModal">
        Cancelar
      </button>
    </div>
  </Modal>
  <ModalQrCode
    :isOpen="state.openModalQrCode"
    @close="state.openModalQrCode = false"
  />
</template>

<script>
//import { offset } from "@popperjs/core";
import TopLayoutClient from "../../layout/compontens/TopLayoutClient.vue";
import services from "../../services";
import { reactive, onMounted } from "vue";
import { useStorage } from "vue3-storage";
import Modal from "../../components/EstruturaModal/EstruturaModal.vue";
import ModalQrCode from "../Modal/ModalQrCode.vue";
export default {
  components: {
    TopLayoutClient,
    Modal,
    ModalQrCode,
  },
  setup() {
    //APP_USR-4145132749873401-060707-5b3e9d8c05e9299c9c5009976481f34c-91539863
    const storage = useStorage();
    var token = storage.getStorageSync("cliente_token");
    var nome = storage.getStorageSync("nome");
    var colaborador_id = storage.getStorageSync("colaborador_id");

    const state = reactive({
      loading: true,
      pesquisa: "",
      pesquisa_mlb: "",
      n_por_paginas: 10,
      pagina_atual: 1,
      n_pagina: 1,
      qtd_paginas: 1,
      modalOpen: false,
      openModalQrCode: false,
    });

    function openModalQrCode() {
      state.openModalQrCode = true;
    }

    onMounted(() => {
      //  ContagemAnuncios();
      fetchAnuncios();
      //  iniciar();
    });

    //Tudo em uma funcao
    async function iniciar() {
      ////Primeiro conta quantos anuncios tem ao total
      state.todos_anuncios = await ContagemAnuncios();

      console.log(state.todos_anuncios.paging.total);

      //divide a quantidade de anuncios por pelo numero de anuncios por páginas
      state.qtd_paginas = Math.ceil(
        state.todos_anuncios.paging.total / state.n_por_paginas
      );

      buscarAnunciosPorPagina(1);
      state.loading = false;
      //chama a página 1 e exibe os anuncios
    }

    async function fetchPorStatus() {
      state.loading = true;
      await services.vendas
        .buscarPorStatus({
          token,
          status: state.status,
        })
        .then((response) => {})
        .catch(() => {})
        .finally(() => {});
    }

    function tornarResponsavel() {
      if (!confirm("Você tem certeza que deseja continuar?")) {
        return;
      }
      state.pedido_selecionado.colaborador_id = colaborador_id;
      state.nome_colaborador = nome;
    }

    async function salvarPedido() {
      state.loading = true;
      await services.vendas
        .salvarPedido({
          token,
          pedido: state.pedido_selecionado,
        })
        .then((response) => {})
        .catch(() => {})
        .finally(() => {
          state.loading = false;
        });
    }

    function formatarData(dataString) {
      const data = new Date(dataString);
      const dia = String(data.getDate()).padStart(2, "0");
      const mes = String(data.getMonth() + 1).padStart(2, "0");
      const ano = data.getFullYear();
      return `${dia}/${mes}/${ano}`;
    }

    async function buscarAnunciosPorPagina(n_pagina) {
      state.n_pagina = n_pagina;
      state.loading = true;
      var offset = (n_pagina - 1) * state.n_por_paginas;
      var pedidos = state.todos_anuncios.results.slice(
        offset,
        offset + state.n_por_paginas
      );

      console.log(pedidos);

      console.log(offset);

      var mlbs = [];
      for (var i = 0; i < pedidos.length; i++) {
        mlbs.push(pedidos[i]);
      }
      await services.pedidos
        .buscarPorPagina({
          token,
          mlbs,
          qtd_pagina: state.qtd_paginas,
          colaborador_id,
        })
        .then((response) => {
          state.anuncios = response.data;

          for (let i = 0; i < state.anuncios.length; i++) {
            console.log(state.anuncios[i].fretes.length);
            for (let i2 = 0; i2 < state.anuncios[i].fretes.length; i2++) {
              console.log(state.anuncios[i].fretes[i2].original);
            }
          }
          state.loading = false;
        })
        .catch(() => {
          alert("Erro ao buscar anuncios!");
          state.loading = false;
        });
    }

    async function ContagemAnuncios() {
      var res = await services.vendas.listarProdutos({
        token,
        colaborador_id,
      });

      return res.data;
    }

    async function fetchAnuncios() {
      state.loading = true;
      await services.vendas
        .pacotesDoDia({
          token,
        })
        .then((response) => {
          state.pedidos = response.data;
          state.loading = false;
        })
        .catch(() => {
          alert("Erro ao buscar pedidos!");
          state.loading = false;
        });
    }

    async function voltarInicial() {
      state.anuncios = state.anuncios_inicial;
      state.pesquisa_mlb = "";
    }

    function abrirModal(pedido) {
      state.pedido_selecionado = pedido;
      state.modalOpen = true;
    }
    function fecharModal() {
      state.modalOpen = false;
    }

    async function fazerPesquisa() {
      state.loading = true;
      if (!state.pesquisa_mlb || state.pesquisa_mlb.trim() === "") {
        await fetchAnuncios();
        return;
      }
      const filtro = state.pedidos.filter(
        (pedido) =>
          pedido.cod_bling === state.pesquisa_mlb ||
          pedido.cod_marketplace === state.pesquisa_mlb
      );
      if (filtro.length > 0) {
        state.pedidos = filtro;
      } else {
        alert("Nenhum pedido encontrado para o SKU informado.");
      }
      state.loading = false;
    }
    function formatarParaReais(valor) {
      return valor.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      });
    }
    return {
      fazerPesquisa,
      formatarData,
      state,
      salvarPedido,
      abrirModal,
      openModalQrCode,
      tornarResponsavel,
      fecharModal,
      fetchPorStatus,
      voltarInicial,
      buscarAnunciosPorPagina,
      formatarParaReais,
    };
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

.skeleton {
  background: #f0f0f0;
  position: relative;
  overflow: hidden;
  border-radius: 4px;
  animation: skeleton-loading 1.5s infinite linear;
}

/* Efeito de brilho passando pelo esqueleto */
@keyframes skeleton-loading {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}

/* Gradiente linear para o efeito de carregamento */
.skeleton::before {
  content: "";
  position: absolute;
  top: 0;
  left: -150%;
  width: 150%;
  height: 100%;
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 25%,
    rgba(220, 220, 220, 0.6) 50%,
    rgba(255, 255, 255, 0) 75%
  );
  animation: shine 1.5s infinite;
}

/* Animação para o efeito de brilho */
@keyframes shine {
  0% {
    left: -150%;
  }
  100% {
    left: 100%;
  }
}

.page-link {
  cursor: pointer;
}

.btn_bread {
  width: auto;
  border-radius: 20px !important;
  padding-left: 20px;
  padding-right: 20px;
}

/* Ajustes no layout */
.skeleton-container {
  display: flex;
  flex-direction: column;
}

.skeleton.h-6 {
  height: 24px; /* Ajuste a altura */
}

.skeleton.w-full {
  width: 100%;
}

.content {
  padding: 4rem;
}

.card {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  height: 140px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 10px;
  border: solid 1px #0000000d;
}

.card #icon_card {
  width: 60px;
  height: 60px;
  margin-right: 15px;
  object-fit: contain;
}

.info p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}
.btns_right {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  text-align: right;
  margin-top: 5rem;
  gap: 0.6rem;
}

.btn_save {
  padding: 5px;
  width: 100px;
  background: #00a000;
  border: solid 2px #000;
  border-radius: 5px;
  transition: 0.2s;
}
.btn_save:hover {
  background: #008000;
}
.btn_cancel {
  padding: 5px;
  width: 100px;
  background: #c4342d;
  border: solid 2px #000;
  border-radius: 5px;
  margin-left: 10px;
  transition: 0.2s;
}
.btn_cancel:hover {
  background: #8f0303;
}
.info h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.coluna {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.coluna h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
}

.coluna-itens {
  padding: 20px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: start;
  width: 100%;
  margin-bottom: 2rem;
}

.info2 {
  margin-left: 15px;
}

.info2 p {
  margin-bottom: 0;
  color: #787878;
  font-size: 18px;
  font-weight: 500;
  font-family: "Poppins", sans-serif;
}

.info2 h3 {
  margin-bottom: 0;
  color: #001942;
  font-size: 26px;
  font-weight: 700;
  font-family: "Poppins", sans-serif;
}

.quad {
  width: 100%;
  background: #ffffff;
  border-radius: 12px;
  border: solid 1px #0000000d;
}

.quad h2 {
  font-weight: 600;
  color: #001942;
  font-size: 24px;
  font-family: "Poppins", sans-serif;
  padding: 10px;
  margin-bottom: 0;
}

.search {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  margin-top: 10px;
  margin-right: 10px;
  margin-bottom: 1rem;
}

.search input {
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 0 45px 45px 0;
  background: #f4f7fe;
}

.search input::placeholder {
  color: #9d9d9d;
}

.btn-primary {
  margin-right: 10px;
}

.search .btn_search {
  border: none;
  outline: none;
  padding: 10px;
  border-radius: 45px 0 0 45px;
  background: #f4f7fe;
  color: #9d9d9d;
}

.search .btn_qrcode {
  border: none;
  outline: none;
  margin-left: 0.25rem;
  border-radius: 50%;
  aspect-ratio: 1 / 1;
  background: #560382;
  color: #b8d941;
  transition: 0.2s ease-in-out;
}

.btn_qrcode:hover {
  background: #b8d941;
  color: #560382;
}

.btn_qrcode i {
  padding: 6px;
}

.search .btn_cancelar {
  border: none;
  outline: none;
  padding: 7px;
  padding-left: 30px;
  margin-left: -20px;
  border-radius: 0 45px 45px 0;
  background: #f4f7fe;
  color: #9d9d9d;
}

.table {
  border-radius: 6px;
  font-family: "Poppins", sans-serif;
}
.table th {
  color: #fff;
}

table.main {
  font-size: 14px;
}

.dropdown-toggle::after {
  display: none;
}
.tornar-responsavel {
  all: unset;
  padding: 0.5rem 1rem;
  border-radius: 0.5rem;
  background-color: #560382;
  color: #fff;
  cursor: pointer;
  transition: 0.2s ease-in-out;
}

.tornar-responsavel:hover {
  filter: brightness(1.5);
}
</style>
